import { Directive, Host, Optional, OnInit, OnDestroy } from '@angular/core';
import { FormControlStatus, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';

/**
 * Fait le lien entre le formControl et l'état d'erreur des
 * composants DSD en ajoutant l'attribut error si le formControl
 * devient invalide
 */
@Directive({
  standalone: false
})
export class BaseFormConnectorDirective extends FormErrorConnectorDirective implements OnInit, OnDestroy {
  statusSubscription: Subscription;

  constructor(@Host() @Optional() private readonly control: NgControl) {
    super();
  }

  ngOnInit() {
    if (!this.control) {
      console.warn("Le composant DSD n'a pas de ngControl associé");
      return;
    }

    if (this.control.errors) {
      this.setInValidState();
    }

    this.statusSubscription = this.control.statusChanges.subscribe(status => this.handleStatusChange(status));
  }

  ngOnDestroy() {
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
  }

  private handleStatusChange(status: FormControlStatus) {
    if (status === 'VALID') {
      this.setInValidState();
    } else if (status === 'INVALID') {
      this.setInErrorState();
    }
  }
}
